import { ChangeDetectionStrategy, Component, computed, inject, RESPONSE_INIT } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthenticationService, ThemeService } from '@core/services';
import { OsButtonDirective, OsIconComponent } from '@shared/ui';

/** Endereço que não existe. Quem está logado volta para Hoje; quem não está, para o site. */
@Component({
	selector: 'os-page-not-found',
	imports: [RouterLink, OsButtonDirective, OsIconComponent],
	template: `
		<div class="status">
			<a class="status__logo" [routerLink]="home()" aria-label="ObraSync">
				<img [src]="logo()" alt="ObraSync" />
			</a>
			<main class="status__main">
				<span class="status__mark" aria-hidden="true"><span class="status__code os-num">404</span></span>
				<div class="status__head">
					<h1>Essa página não está na planta</h1>
					<p>O endereço pode ter mudado ou o link veio cortado. Se era uma obra, procure por ela na lista.</p>
				</div>
				<div class="status__actions">
					<a [routerLink]="home()" osButton size="lg">
						<os-icon [size]="18" name="hoje" />
						{{ signedIn() ? 'Ir para Hoje' : 'Ir para o início' }}
					</a>
					@if (signedIn()) {
						<a osButton="secondary" size="lg" routerLink="/app/projects">Ver as obras</a>
					}
				</div>
			</main>
		</div>
	`,
	styleUrl: './status-page.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
	private readonly theme = inject(ThemeService);
	/** No servidor, a resposta sai com 404 (artigo que não existe, endereço errado...). */
	private readonly response = inject(RESPONSE_INIT, { optional: true });
	readonly signedIn = inject(AuthenticationService).isAuthenticated;
	readonly home = computed(() => (this.signedIn() ? '/app/today' : '/'));
	readonly logo = computed(() => `assets/images/logo/logo-horizontal${this.theme.dark() ? '-brand' : ''}.png`);

	constructor() {
		if (this.response) this.response.status = 404;
	}
}
